import { Badge } from "@/components/ui/badge";
import { Shield, CreditCard } from "lucide-react";

export function SecurityBadges() {
  return (
    <div className="flex gap-2 justify-center">
      <Badge variant="secondary" className="flex items-center gap-1">
        <Shield className="h-4 w-4" />
        Secure Payment
      </Badge>
      <Badge variant="secondary" className="flex items-center gap-1">
        <CreditCard className="h-4 w-4" />
        Bank-Level Security
      </Badge>
    </div>
  );
}